export const paramValueToNumber = (x: string | string[]) => {
  const n = parseInt(Array.isArray(x) ? x[0] : x)
  return isNaN(n) ? null : n
}
